export default "__VITE_ASSET__DraMUL1l__"